import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'

import { framework_tool, utils_tool, component_tool } from '../../../tool'
let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizBrowserExport, WizModal, WizButton } = component_tool;
let { checkStrLength } = utils_tool;

import '@/styles/containers/organization/organization/index.less'

const _getValue = (type, key) => {
  const values = {
    state: {
      1: '有效',
      0: '无效'
    },

  };
  return values[type][key]
};
class Organization extends WizContainer {

  componentName = 'Organization';

  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      modal: {}
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleTreeData(nextProps, nextState, key) {
    let o = nextProps[key]
    let len = 20
    if (o['success']) {
      let f = (v) => {
        v && v.forEach(val => {
          val['title'] = checkStrLength(val['title'], len);
          if (val['children'] && val['children'].length > 0) {
            f(val['children'])
          }
        });
      }
      f(o['data'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }



  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '组织id',
        field: 'id',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '组织名称',
        field: 'name',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '组织编码',
        field: 'code',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '组织类型',
        field: 'organizationNodeCategoryName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '状态',
        field: 'state',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '上级组织',
        field: 'orgPathName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '上级组织编码',
        field: 'parentCode',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '创建人',
        field: 'createBy',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '创建人时间',
        field: 'createTime',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '修改人',
        field: 'updateBy',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '修改时间',
        field: 'updateTime',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
    ]
    if (o['success']) {
      let data = Object.assign([], o['data'])
      data.forEach((val, index) => {
        val['state'] = _getValue('state', val['state'])
      })
      WizBrowserExport({
        title: '组织机构信息',
        sheetName: '组织机构信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '组织机构信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _btnFun = ({ record }) => {
    let path = '无'
    if (record['orgPathName']) {
      let pathList = record['orgPathName'].split('>')
      path = pathList[pathList.length > 1 ? pathList.length - 2 : '无']
    }
    this.setState({
      visible: true,
      modal: { ...record, orgPathName: path, state: record['state'] === 1 ? '有效' : '无效' }
    })
  }

  _modal(visible, modal) {
    let renderItem = (title, key) => {
      return (
        <div className='modal-row'>
          <div className='row-title'>{title}：</div>
          <div className='row-value'>{key}</div>
        </div>
      )
    }
    let item = [
      { title: '上级组织', key: 'orgPathName' },
      { title: '组织名称', key: 'name' },
      { title: '组织编码', key: 'code' },
      { title: '组织类型', key: 'organizationNodeCategoryName' },
      { title: '状态', key: 'state' },
    ]
    return (
      <WizModal
        visible={visible}
        title='查看'
        width={700}
        onCancel={() => { this.setState({ visible: false, modal: {} }) }}
        footer={
          <WizButton
            type='primary'
            onClick={() => { this.setState({ visible: false, modal: {} }) }}
          >确定</WizButton>
        }
        forceRender
      >
        <div className='organization-modal'>
          {item.map(({ title, key }) => {
            return renderItem(title, modal[key])
          })}
        </div>
      </WizModal>
    )
  }

  _render() {
    let { visible, modal } = this.state
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig({ _btnFun: (e) => { this._btnFun(e) } }),
      apiDataFormat: {
        add: this._handleCMD,
        update: this._handleCMD,
        delete: this._handleCMD,
        treeData: this._handleTreeData,
        enable: this._handleCMD,
        export: this._handleFile,
      },
    })
    return <>
      <WizReduxTemplate {..._reduxTemplateCofig} />
      {this._modal(visible, modal)}
    </>
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(Organization);
